import { createRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { z } from 'zod';
import { Route as rootRoute } from './__root';
import { useAuthStore } from '../store/auth.store';
import type { OperatorRole } from '@netsuite-ai/types';

const searchSchema = z.object({ token: z.string().catch('') });

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/accept-invite',
  validateSearch: searchSchema,
  component: AcceptInvitePage,
});

function AcceptInvitePage() {
  const { token } = Route.useSearch();
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError('Missing invite token.');
      return;
    }

    fetch(`/api/console/auth/verify?token=${token}`)
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          setError(data.error ?? 'Invalid link.');
          return;
        }

        // Decode JWT payload to extract role (no sig verification needed client-side)
        const payload = JSON.parse(atob(data.accessToken.split('.')[1]));
        setSession(data.accessToken, payload.role as OperatorRole);
        navigate({ to: '/' });
      })
      .catch(() => setError('Something went wrong.'));
  }, [token]);

  if (error)
    return <p className="text-danger py-20 text-center text-sm">{error}</p>;
  return (
    <p className="text-muted py-20 text-center text-sm">Accepting invite…</p>
  );
}
